import { FC } from 'react';
import cn from 'classnames';
import { UiText, UiTitle } from '@frontend/znanie-uikit';

import { decl } from 'utils/helpers';

import { Timer } from 'components/common/Timer';

import { UserScore } from '../UserScore';
import { CinemaWeek } from '../CinemaWeek';
import { UserMultiplier } from '../UserMultiplier';

import * as DailyQuestionC from '../../DailyQuestion.const';

import * as C from './WaitingBlock.const';
import * as T from './WaitingBlock.types';
import css from './WaitingBlock.module.scss';

export const WaitingBlock: FC<T.IWaitingBlock> = (props) => {
  const answersCount = props.answersCount ?? 0;

  return (
    <div className={css.container}>
      <div className={css.titleBlock}>
        <UiTitle
          size="big"
          className={cn(css.title, props.isDarkTheme && css.darkTheme)}
        >
          {C.TITLE_TEXT}
        </UiTitle>

        <div className={css.titleBlockRow}>
          <UiText
            className={cn(
              css.userParamWrapper,
              props.isDarkTheme && css.darkTheme
            )}
          >
            Ты ответил уже на{' '}
            <div className={css.answersCount}>
              {answersCount}{' '}
              {decl(answersCount, ['вопрос', 'вопроса', 'вопросов'])}
            </div>
          </UiText>
        </div>

        <div className={css.titleBlockRow}>
          <UiText
            className={cn(
              css.userParamWrapper,
              props.isDarkTheme && css.darkTheme
            )}
          >
            Всего{' '}
            <UserScore className={css.userParam} score={props.userScore} />
          </UiText>

          <UiText
            className={cn(
              css.userParamWrapper,
              props.isDarkTheme && css.darkTheme
            )}
          >
            Множитель{' '}
            <UserMultiplier
              className={css.userParam}
              multiplier={props.multiplier}
            />
          </UiText>
        </div>
      </div>

      <div className={css.rightBlock}>
        {props.isCinemaWeek && <CinemaWeek />}

        <div className={css.timerWrapper}>
          <Timer
            utcHour={DailyQuestionC.SWITCH_QUESTION_UTC_HOUR}
            onTimerEnd={props.onTimerEnd}
          />

          <UiText
            className={cn(css.timerHint, props.isDarkTheme && css.darkTheme)}
            size="small"
          >
            До публикации следующего вопроса
          </UiText>
        </div>
      </div>
    </div>
  );
};
